module.exports = __webpack_public_path__ + "static/media/otcLogo.a7dbb7a9.png";